import React, { useState, useEffect, useCallback } from "react";
import { customFetch } from '../apiClient';

const DischargeServicesModal = ({ show, ipdId, onClose }) => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editData, setEditData] = useState({});
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);

  const fetchServices = useCallback(async () => {
    if (!ipdId) return;
    setLoading(true);
    try {
      const res = await customFetch(`/IPDServiceDetailDT/by-ipd/${ipdId}`);
      if (!res.ok) throw new Error("No services found");
      const data = await res.json();
      setServices(data);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, [ipdId]);

  useEffect(() => {
    if (show) fetchServices();
  }, [show, fetchServices]);

  const startEditing = (service) => {
    setEditId(service.servSrNo);
    setEditData({
      qty: service.qty,
      servRate: service.servRate,
      amount: service.amount,
      remarks: service.remarks
    });
  };

  const handleChange = (field, value) => {
    setEditData(prev => {
        const updated = { ...prev, [field]: value };
        if (field === "qty" || field === "servRate") {
            updated.amount = (updated.qty * updated.servRate).toFixed(2);
        }
        return updated;
    });
  };

  const saveService = async () => {
    if (!editId) return;
    try {
     const original = services.find(s => s.servSrNo === editId);
const updated = { ...original, ...editData, qty: Number(editData.qty), servRate: Number(editData.servRate), amount: Number(editData.amount) };

const res = await customFetch(`/IPDServiceDetailDT/${editId}`, {
  method: "PUT",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify(updated),
});
      if (res.ok) {
        setMessage("Service updated");
        setEditId(null);
        fetchServices();
      } else {
         throw new Error("Update failed");
      }
    } catch (e) {
      setError(e.message);
    }
  };

  const deleteService = async (id) => {
    if (!window.confirm("Delete this service?")) return;
    try {
     const res = await customFetch(`/IPDServiceDetailDT/${id}`, {
  method: "DELETE"
});
      if (res.ok) {
        setMessage("Service deleted");
        fetchServices();
      }
    } catch (e) {
      setError(e.message);
    }
  };

  if (!show) return null;

  return (
    <div className="nested-modal-overlay">
      <div className="nested-modal-container">
        <div className="nested-modal-header">
          <h5>Manage Service Details</h5>
          <button className="btn-close" onClick={onClose}><i className="bi bi-x-lg"></i></button>
        </div>
        <div className="nested-modal-body">
          {error && <div className="alert alert-danger">{error}</div>}
          {message && <div className="alert alert-success">{message}</div>}
          
          <div className="table-responsive">
            <table className="table table-bordered table-sm">
              <thead className="table-light">
                <tr>
                  <th>Service</th>
                  <th>Qty</th>
                  <th>Rate</th>
                  <th>Amount</th>
                  <th>Remarks</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {loading ? <tr><td colSpan="6" className="text-center">Loading...</td></tr> : 
                 services.length === 0 ? <tr><td colSpan="6" className="text-center">No services found</td></tr> :
                 services.map(s => (
                  <tr key={s.servSrNo}>
                    <td>{s.serviceName}</td>
                    <td>{editId === s.servSrNo ? <input type="number" className="form-control form-control-sm" value={editData.qty} onChange={e => handleChange('qty', e.target.value)} /> : s.qty}</td>
                    <td>{editId === s.servSrNo ? <input type="number" className="form-control form-control-sm" value={editData.servRate} onChange={e => handleChange('servRate', e.target.value)} /> : s.servRate}</td>
                    <td>{editId === s.servSrNo ? editData.amount : s.amount}</td>
                    <td>{editId === s.servSrNo ? <input type="text" className="form-control form-control-sm" value={editData.remarks} onChange={e => handleChange('remarks', e.target.value)} /> : s.remarks}</td>
                    <td>
                      {editId === s.servSrNo ? (
                        <>
                          <button className="btn btn-sm btn-success me-1" onClick={saveService}><i className="bi bi-check"></i></button>
                          <button className="btn btn-sm btn-secondary" onClick={() => setEditId(null)}><i className="bi bi-x"></i></button>
                        </>
                      ) : (
                        <>
                          <button className="btn btn-sm btn-primary me-1" onClick={() => startEditing(s)}><i className="bi bi-pencil"></i></button>
                          <button className="btn btn-sm btn-danger" onClick={() => deleteService(s.servSrNo)}><i className="bi bi-trash"></i></button>
                        </>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <style jsx>{`
        .nested-modal-overlay {
          position: fixed;
          top: 0; left: 0; right: 0; bottom: 0;
          background: rgba(0,0,0,0.6);
          z-index: 10000;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .nested-modal-container {
          background: white;
          width: 90%;
          max-width: 900px;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 5px 15px rgba(0,0,0,0.3);
        }
        .nested-modal-header {
          background: #f8f9fa;
          padding: 10px 15px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid #ddd;
        }
        .nested-modal-body {
          padding: 15px;
          max-height: 70vh;
          overflow-y: auto;
        }
        .btn-close { background: none; border: none; font-size: 1.2rem; }
      `}</style>
    </div>
  );
};

export default DischargeServicesModal;